// ---------------------------------------------------------------------------
// Employers (HubSpot contact type "Employer / HR Leader")
// ---------------------------------------------------------------------------
// Employers sit outside the broker T1-T5 ladder: they get their own mode, a
// dedicated marker palette keyed on Industry, and a per-state density overlay.
export const EMPLOYER_KIND = "employer";
export const EMPLOYER_COLOR = "#F59E0B";
export const EMPLOYER_GLOW = "rgba(245, 158, 11, 0.65)";
export const UNKNOWN_INDUSTRY = "Unspecified";

export function industryOf(contact) {
  return (contact?.industry || "").trim() || UNKNOWN_INDUSTRY;
}

// Stable colour per industry name, so the legend matches the map across
// reloads. Hue-spread rather than a fixed palette, so two industries in the
// same view don't land on the same swatch.
export function industryColor(industry) {
  const name = (industry || UNKNOWN_INDUSTRY).trim().toLowerCase();
  if (name === UNKNOWN_INDUSTRY.toLowerCase()) return "#71717A";
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 131 + name.charCodeAt(i)) % 360;
  // Skip the 200-230 band so industries never read as the cyan UI accent.
  const hue = h >= 200 && h <= 235 ? (h + 60) % 360 : h;
  return `hsl(${hue}, 72%, 62%)`;
}

export function industryCounts(employers) {
  const counts = new Map();
  for (const e of employers) {
    const key = industryOf(e);
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  return [...counts.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
}
